import React from 'react';
import { SimpleCardData } from '../common/types';
import { motion, useMotionTemplate, useMotionValue, MotionValue } from "framer-motion";
import { GridPattern } from './GridPattern';
import { Link } from 'react-router-dom';

function Effect({ mouseX, mouseY, ...gridProps }: { mouseX: MotionValue<number>, mouseY: MotionValue<number>, [key: string]: any }) {
    let maskImage = useMotionTemplate`radial-gradient(300px at ${mouseX}px ${mouseY}px, white, transparent)`;
    let style = { maskImage, WebkitMaskImage: maskImage };

    return (
        <div className="pointer-events-none">
            <div className="pointer-events-none">
                <div className="absolute inset-0 rounded-lg transition duration-300 [mask-image:linear-gradient(white,transparent)] group-hover:opacity-100">
                    <GridPattern
                        width={72}
                        height={56}
                        x="50%"
                        y={gridProps.y}
                        className="absolute inset-x-0 inset-y-[-30%] h-[160%] w-full skew-y-[-18deg] fill-black/[0.02] stroke-black/5"
                        squares={gridProps.squares}
                    />
                </div>
                <motion.div
                    className="absolute inset-0 rounded-lg bg-gradient-to-r from-[#D7EDEA] to-[#F4FBDF] opacity-0 transition duration-300 group-hover:opacity-100"
                    style={style}
                />
                <motion.div
                    className="absolute inset-0 rounded-lg opacity-0 mix-blend-overlay transition duration-300 group-hover:opacity-100"
                    style={style}
                >
                    <GridPattern
                        width={72}
                        height={56}
                        x="50%"
                        y={gridProps.y}
                        className="absolute inset-x-0 inset-y-[-30%] h-[160%] w-full skew-y-[-18deg] fill-black/[0.02] stroke-black/5"
                        squares={gridProps.squares}
                    />
                </motion.div>
            </div>
        </div>
    );
}


const SimpleCard: React.FC<SimpleCardData> = ({ image, title, count }) => {
    let mouseX = useMotionValue(0);
    let mouseY = useMotionValue(0);
    const pattern = {
        y: 16,
        squares: [
            [-1, 1],
            [0, 3]
        ],
    };
    function onMouseMove({ currentTarget, clientX, clientY }: React.MouseEvent<HTMLDivElement>) {
        let { left, top } = currentTarget.getBoundingClientRect();
        mouseX.set(clientX - left);
        mouseY.set(clientY - top);
    }

    return (
        <Link to={`${title.toLowerCase().replace(/ /g, '-')}`}>
            <div
                onMouseMove={onMouseMove}
                className='group flex flex-col items-center justify-between bg-white border border-gray-200 p-10 rounded-xl h-[230px] font-jarkarta relative max-w-sm'
            >
                <Effect {...pattern} mouseX={mouseX} mouseY={mouseY} />
                <div className="h-full w-20 ekc-image-gradient" style={{
                    maskImage: `url(${image})`,
                    WebkitMaskImage: `url(${image})`,
                    maskSize: 'contain',
                    WebkitMaskSize: 'contain',
                    maskRepeat: 'no-repeat',
                    WebkitMaskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    WebkitMaskPosition: 'center',
                    backgroundColor: 'transparent',
                }} />
                <div className="relative z-10">
                    <h3 className='font-medium text-lg mb-2 text-center whitespace-nowrap'>{title}</h3>
                </div>
            </div>
        </Link>
    );
};

export default SimpleCard